import React from "react";

function HomeScreenMultiPlatform() {
  return (
    <div className="container text-center" style={{ marginTop: "6rem" }}>
      <img
        loading="lazy"
        className="w-50"
        src="./images/multi_platform.png"
        alt="multi platform supported"
      />
      <div className="mt-5">
        <label className="fs-5">Supports multiple platforms</label>
      </div>
    </div>
  );
}

export default HomeScreenMultiPlatform;
